module.exports = __webpack_public_path__ + "static/media/12583693_1044190468957126_564574497_n_edited.5b1a4833.jpg";